import React from 'react'
import ModalStyle from "./ModalStyle.module.css"
import loading from '../../assets/thumb.png'
const Modal = () => {
    return (
        <>
        <div className={ModalStyle.modal}>
            <div className={ModalStyle.img}>
            <img style={{ width: "100%",height:'100%' }} src={loading} alt="top"/>
            </div>        </div>
        </>
    )
}

export default Modal
